// src/components/Search/S2DownloadLinksDisplay.js
import React, { useRef } from 'react';
import { getResolution } from '../../utils/qualityUtils';
import { FaDownload } from 'react-icons/fa';

export default function S2DownloadLinksDisplay({ links, selectedResult }) {
  const downloadSectionRef = useRef(null);

  const renderSelectedResult = () => (
    <div className="flex items-center space-x-6 mb-6 bg-gray-800 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 duration-200">
      {selectedResult.photoUrl ? (
        <img
          src={selectedResult.photoUrl}
          alt={selectedResult.title || selectedResult.name}
          className="w-28 h-40 object-cover rounded-lg shadow-md"
        />
      ) : (
        <div className="w-28 h-40 bg-gray-700 flex items-center justify-center rounded-lg">
          <span className="text-sm text-gray-300">No Image</span>
        </div>
      )}
      <div className="flex flex-col text-left space-y-2">
        <h3 className="text-2xl font-semibold text-accent leading-snug">
          {selectedResult.title || selectedResult.name}
        </h3>
        <p className="text-sm text-gray-300">{selectedResult.year} • Movie</p>
        {selectedResult.description && (
          <p className="text-gray-400 text-sm leading-relaxed mt-2 line-clamp-3">
            {selectedResult.description.length > 200 ? `${selectedResult.description.substring(0, 200)}...` : selectedResult.description}
          </p>
        )}
      </div>
    </div>
  );

  const renderDownloadButton = (link, quality, type, title) => {
    const resolution = getResolution(quality);
    const badgeColor = resolution >= 1080 ? 'bg-green-500' : resolution >= 720 ? 'bg-yellow-500' : 'bg-red-500';

    return (
      <a
        key={link.url}
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-gray-900 p-6 rounded-xl shadow-lg hover:shadow-2xl transition transform hover:scale-105 duration-300 flex flex-col justify-between"
        aria-label={`Download ${title} at ${quality}`}
      >
        <div className="flex items-center space-x-3">
          <FaDownload className="text-accent text-2xl" />
          <h4 className="text-xl font-semibold text-white">{title}</h4>
        </div>
        <div className="mt-4 flex flex-wrap items-center space-x-2">
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${badgeColor} text-white`}>{quality}</span>
          <span className="px-3 py-1 rounded-full text-sm font-medium bg-blue-500 text-white">{type}</span>
        </div>
      </a>
    );
  };

  return (
    <div className="p-6 w-full max-w-6xl mx-auto relative" ref={downloadSectionRef}>
      {/* Display selected result at the top */}
      {selectedResult && renderSelectedResult()}

      <h3 className="text-3xl font-bold mb-6">Available Downloads</h3>

      {links.contentType === 'Movie' && links.downloadLinks?.length > 0 && (
        <div className="mb-8">
          <h4 className="text-2xl font-semibold text-accent mb-4">Movie</h4>
          <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
            {links.downloadLinks.map((link) =>
              renderDownloadButton(link, link.quality, link.type, 'Download Link')
            )}
          </div>
        </div>
      )}

      {links.contentType === 'Series' && links.seasons?.length > 0 && (
        <div>
          <h4 className="text-2xl font-semibold text-accent mb-4">TV Show</h4>
          {links.seasons.map((season, idx) => (
            <div key={idx} className="mb-6">
              <h5 className="text-xl font-semibold text-accent mb-2">
                {season.seasonNumber} - {season.quality} - {season.type}
              </h5>
              <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                {season.episodes.map((episode) =>
                  renderDownloadButton(episode, season.quality, season.type, episode.episodeNumber)
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      
    </div>
  );
}
